import { useTranslation } from 'react-i18next';
import useFetchEmployees from 'components/domain/employee/useFetchEmployees';
import SelectField from 'components/forms/selectField/SelectField';
import { PropertyBusinessType } from 'models/Properties';
import FieldPlaceholder from 'pages/property/common/FieldPlaceholder';
import usePropertySettingsInitData from '../../../usePropertySettingsInitData';

const PrimaryContactField = () => {
  const { t } = useTranslation();

  const { employees, isFetching: isLoadingEmployees } = useFetchEmployees(true);
  const { property } = usePropertySettingsInitData();

  if (isLoadingEmployees) {
    return (
      <FieldPlaceholder
        label={t(
          'pageProperty.mainSettings.bookingDotComSettings.primaryContact',
        )}
        name="bookingDotComSettings.primaryContactUid"
        colSmInput={7}
        colSmLabel={5}
        required
      />
    );
  }

  const primaryContactOptions = [
    { value: '', label: t('common.select') },
    ...(employees ?? []).map(({ uid, bestProfile }) => ({
      value: uid,
      label: bestProfile,
    })),
  ];

  const isFieldRequired = property?.businessType !== PropertyBusinessType.HOTEL;

  return (
    <SelectField
      label={t(
        'pageProperty.mainSettings.bookingDotComSettings.primaryContact',
      )}
      name="bookingDotComSettings.primaryContactUid"
      options={primaryContactOptions}
      colSmInput={7}
      colSmLabel={5}
      required={isFieldRequired}
    />
  );
};

export default PrimaryContactField;
